import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PricingComponent } from "@/app/billing/upgrade/upgrade";

function PricingSkeleton() {
  return (
    <div className="mt-4">
      <div className="mx-auto grid w-full grid-cols-1 gap-6 px-2 lg:grid-cols-2 xl:grid-cols-3">
        <Skeleton className="h-[420px] rounded-xl" />
        <Skeleton className="h-[420px] rounded-xl" />
        <Skeleton className="h-[420px] rounded-xl" />
      </div>
    </div>
  );
}

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/billing/upgrade/"
)({
  component: () => (
    <Suspense fallback={<PricingSkeleton />}>
      <PricingComponent />
    </Suspense>
  ),
  loader: () => ({
    crumb: "Pricing",
  }),
});
